import { useEffect, useRef, useState } from 'react';

export function Comms({ queue, paused, onDone, onPing }) {
  const line = queue[0];
  const remaining = useRef(0);
  const [visible, setVisible] = useState(null);
  useEffect(() => {
    remaining.current = line?.durationMs ?? 3500;
    setVisible(line);
    if (line) onPing(line);
  }, [line, onPing]);
  useEffect(() => {
    if (!line || paused) return;
    const started = performance.now();
    const timer = setTimeout(onDone, remaining.current);
    return () => {
      clearTimeout(timer);
      remaining.current = Math.max(0, remaining.current - (performance.now() - started));
    };
  }, [line, paused, onDone]);
  if (!visible) return null;
  return (
    <aside className="comms" aria-live="polite" aria-atomic="true">
      <span className="comms__portrait" aria-hidden="true">
        {visible.speaker[0]}
      </span>
      <div>
        <strong>
          {visible.speaker === 'Mikey' ? 'Mikey · thoughts' : `${visible.speaker} · comms`}
        </strong>
        <p>{visible.text}</p>
      </div>
    </aside>
  );
}
